import React, { useContext } from 'react';
import { Link } from 'react-router';
import { SpinnerArea, Table, TablePagination } from '../../../shared/components';
import operationService from '../../../services/operationService';
import useServiceReducer from '../../../shared/hooks/useServiceReducer';
import { MiciCaseFilter, OperationMiciCase, QueryGroup } from '../../../services/types/Operation';
import { Cell } from '../../../shared/components/Table';
import { dateStr } from '../../../shared/misc/utils';
import OperationContext from './context';
import miciCaseReducer from './miciCasesReducer';
import {} from '../../../services/types/MiciCases';
import StatusBadge from '../../MiciCases/StatusBadge';

const MICICases: React.FC = () => {
  const {
    operation: { id, number },
  } = useContext(OperationContext);

  const initFilter: MiciCaseFilter = {
    operationId: id,
    pageNumber: 1,
    sortField: 'id',
    sortDescending: false,
    queryGroup: QueryGroup.All,
  };

  const [data, loading, filter, dispatch] = useServiceReducer(
    operationService.getMiciCases,
    miciCaseReducer,
    initFilter
  );

  const pageSize = 8;
  const changePage = (page: number) => dispatch({ type: 'PAGE', value: page });
  const changeSort = (column: string, descending: boolean) =>
    dispatch({ type: 'ORDER', column, descending });

  const cells: Cell<OperationMiciCase>[] = [
    {
      name: 'number',
      value: (x) => x.number,
      render: (x, o) => (
        <Link
          to={id ? `/mici-cases/${o.number}?operationNumber=${number}` : `/mici-cases/${o.number}`}
        >
          {x}
        </Link>
      ),
      column: 'miciComplaintRegister',
    },
    {
      name: 'status',
      value: (x) => x.status,
      column: 'miciStatus',
      render: (x) => <StatusBadge code={x} />,
    },
    {
      name: 'stage',
      value: (x) => x.stage,
      column: 'miciStage',
    },
    {
      name: 'receiptDate',
      value: (x) => dateStr(x.receiptDate),
    },
    {
      name: 'registerDate',
      value: (x) => dateStr(x.registerDate),
    },
  ];

  return (
    <SpinnerArea loading={loading}>
      {data && data.total > 0 && (
        <>
          <Table
            data={data.list}
            cells={cells}
            keyFunc={(x) => x.id}
            sortData={filter}
            changeSort={changeSort}
          />
          <TablePagination
            pageSize={pageSize}
            pageNumber={filter.pageNumber}
            total={data.total}
            onChangePage={changePage}
          />
        </>
      )}
    </SpinnerArea>
  );
};

export default MICICases;
